import React from 'react';
import Lazy from '@prisjakt/ui-lazy';
import { RegularPriceRow } from './regular';
import { usePriceRowContext } from '../../price-row-context';
import { RowCard, Row } from './styles';
import { useDispatch } from 'react-redux';
import {
  productPriceClick,
  productClickOutBounce,
} from 'src/areas/product/actions/product';
import { IPriceRow } from '../types';
import { ProductPriceClickStatus } from 'src/areas/product/actions/types';

export const PriceRow: React.FC<IPriceRow> = props => {
  const { item, index } = props;
  const { productId } = usePriceRowContext();
  const rowKey = `${item.id}-${index}`;
  const dispatch = useDispatch();

  return wrapLazy(
    index,
    rowKey,
    <RegularPriceRow
      key={rowKey}
      onClickOutBounce={() => {
        dispatch(productClickOutBounce(productId, item.id));
      }}
      onPriceClick={(
        featured: boolean,
        price: number | undefined,
        status: ProductPriceClickStatus,
        isAlternative: boolean
      ) => {
        // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
        // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
        dispatch(
          productPriceClick(productId, item, featured, status, isAlternative)
        );
      }}
    />
  );
};

const lazyPlaceholder = (
  <RowCard>
    <Row />
  </RowCard>
);

const wrapLazy = (
  order: number,
  rowKey: string,
  component: React.ReactElement
) => {
  if (order > 10) {
    return (
      <Lazy placeholder={lazyPlaceholder} offset={200} key={rowKey}>
        {component}
      </Lazy>
    );
  }
  return component;
};
